var _circle, _circle2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.838,
    cy: 16.4,
    r: 2.85,
    stroke: "#F89521",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.162,
    cy: 16.4,
    r: 2.85,
    stroke: "#F89521",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.338 15.345a.75.75 0 0 0 0 1.5v-1.5zm1.8 0h-1.8v1.5h1.8v-1.5zM20.662 16.845a.75.75 0 1 0 0-1.5v1.5zm0-1.5h-1.8v1.5h1.8v-1.5z",
    fill: "#F89521"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.31 16.355c0-.717-.587-1.3-1.31-1.3-.724 0-1.31.583-1.31 1.3",
    stroke: "#F89521",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.742h20M6.178 7.85h11.644M18.509 9.98l-1.12-4.57c-.305-1.244-1.7-1.905-2.942-1.59-.739.187-1.587.331-2.447.331-.86 0-1.708-.144-2.447-.332-1.241-.314-2.637.347-2.942 1.59L5.491 9.98",
    stroke: "#F89521",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnon);
export default __webpack_public_path__ + "static/media/anon.169274290958bfb957ee9c2feb13edeb.svg";
export { ForwardRef as ReactComponent };